import { render } from "./chatRightList.vue?vue&type=template&id=1e2472a7"
import script from "./chatRightList.vue?vue&type=script&lang=js"
export * from "./chatRightList.vue?vue&type=script&lang=js"

import "./chatRightList.vue?vue&type=style&index=0&id=1e2472a7&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__